import React, { useEffect, useState } from "react";
import "./Package.css";
import Topheader from "../topheader/topheader";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";

const Package = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [packages, setPackages] = useState([]);
  const [packagesbyid, setPackagesbyid] = useState("");
  const [tutorid, setTutorid] = useState("");

  useEffect(() => {
    const fetchSubjects = async () => {
      try {
        const response = await axios.get(
          "https://apifrwrd.smplyrefer.com/api/allpackega"
        );
        setPackages(response.data);
        console.log("response", response.data);
      } catch (error) {
        console.error("Error fetching subjects:", error);
      }
    };
    fetchSubjects();
  }, []);

  const fetchpachagebyid = async (packageid) => {
    try {
      const response = await axios.get(
        `https://apifrwrd.smplyrefer.com/api/packega/${packageid}`
      );
      setPackagesbyid(response?.data);
      console.log("contractorsbyid???", response?.data);
    } catch (error) {
      console.error("Error fetching subjects:", error);
    }
  };

  useEffect(() => {
    const fetchSubjects = async () => {
      try {
        const response = await axios.get(
          `https://apifrwrd.smplyrefer.com/api/contractorsbyid/${id}`
        );
        setTutorid(response?.data?.id);
        // console.log('contractorsbyid???',response?.data?.id);
      } catch (error) {
        console.error("Error fetching subjects:", error);
      }
    };
    fetchSubjects();
  }, []);

  const handleNext = () => {
    if (packagesbyid?.id) {
      navigate(`/packagedetails/${packagesbyid.id}`);
    }
  };
  console.log("packages", packages);

  return (
    <>
      <Topheader />
      <div className="body-with-fixed-header">
        <div className="package-container">
          <h4 className="mb-4 font-weight-bold">Select Package</h4>

          <div className="package-grid">
            {packages.map((pkg, index) => (
              // <Link to={`/packagedetails/${tutorid}/${pkg.id}`} key={index} className="package-link">
              // <Link to={`/packagedetails/${pkg.id}`} key={index} className="package-link">

              <div
                className={`package-card ${pkg.name}`}
                onClick={() => fetchpachagebyid(pkg.id)}
                
                 data-toggle="modal"
        data-target="#exampleModalLong"
              >
                <div className="package-header">
                  <h4>{pkg.name.toUpperCase()}</h4>
                  <span className="class-count">
                    {pkg.numberofclass} Classes
                  </span>
                </div>
                <div className="row feature-list">
                  {pkg.description
                    .split(/<br\s*\/?>|\n/g) // split on <br>, <br/>, or \n
                    .filter((item) => item.trim()) // remove empty lines
                    .map((item, idx) => (
                      <div className="col-6 feature-item" key={idx}>
                        <span
                          dangerouslySetInnerHTML={{ __html: item.trim() }}
                        />
                      </div>
                    ))}
                </div>
              </div>
              // </Link>
            ))}
          </div>
        </div>
      </div>
      {/* <button
        className="btn btn-primary"
        data-toggle="modal"
        data-target="#exampleModalLong"
      >
        Term
      </button> */}

      <div
        className="modal fade"
        id="exampleModalLong"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="exampleModalLongTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">
                Terms & conditions
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div
              className="modal-body"
              style={{ height: "350px", overflowY: "auto" }}
            >
              <p>
                <strong>1 Terms</strong>
                <br />
                Cras mattis consectetur purus sit amet fermentum. Cras justo
                odio, dapibus ac facilisis in, egestas eget quam. Morbi leo
                risus, porta ac consectetur ac, vestibulum at eros. Praesent
                commodo cursus magna, vel scelerisque nisl consectetur et.
                Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor
                auctor. Aenean lacinia bibendum nulla sed consectetur. Praesent
                commodo cursus magna, vel scelerisque nisl consectetur et. Donec
                sed odio dui. Donec ullamcorper nulla non metus auctor
                fringilla. Cras mattis consectetur purus sit amet fermentum.
                Cras justo odio, dapibus ac facilisis in, egestas eget quam.
                Morbi leo risus, porta ac consectetur ac, vestibulum at eros.
                Praesent commodo cursus magna, vel scelerisque nisl consectetur
                et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus
                dolor auctor. Aenean lacinia bibendum nulla sed consectetur.
                Praesent commodo cursus magna, vel scelerisque nisl consectetur
                et. Donec sed odio dui. Donec ullamcorper nulla non metus auctor
                fringilla. Cras mattis consectetur purus sit amet fermentum.
                Cras justo odio, dapibus ac facilisis in, egestas eget quam.
                Morbi leo risus, porta ac consectetur ac, vestibulum at eros.
                Praesent commodo cursus magna, vel scelerisque nisl consectetur
                et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus
                dolor auctor. Aenean lacinia bibendum nulla sed consectetur.
                Praesent commodo cursus magna, vel scelerisque nisl consectetur
                et. Donec sed odio dui. Donec ullamcorper nulla non metus auctor
                fringilla. Cras mattis consectetur purus sit amet fermentum.
                Cras justo odio, dapibus ac facilisis in, egestas eget quam.
                Morbi leo risus, porta ac consectetur ac, vestibulum at eros.
                Praesent commodo cursus magna, vel scelerisque nisl consectetur
                et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus
                dolor auctor. Aenean lacinia bibendum nulla sed consectetur.
                Praesent commodo cursus magna, vel scelerisque nisl consectetur
                et. Donec sed odio dui. Donec ullamcorper nulla non metus auctor
                fringilla. Cras mattis consectetur purus sit amet fermentum.
                Cras justo odio, dapibus ac facilisis in, egestas eget quam.
                Morbi leo risus, porta ac consectetur ac, vestibulum at eros.
                Praesent commodo cursus magna, vel scelerisque nisl consectetur
                et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus
                dolor auctor. Aenean lacinia bibendum nulla sed consectetur.
                Praesent commodo cursus magna, vel scelerisque nisl consectetur
                et. Donec sed odio dui. Donec ullamcorper nulla non metus auctor
                fringilla. Cras mattis consectetur purus sit amet fermentum.
                Cras justo odio, dapibus ac facilisis in, egestas eget quam.
                Morbi leo risus, porta ac consectetur ac, vestibulum at eros.
                Praesent commodo cursus magna, vel scelerisque nisl consectetur
                et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus
                dolor auctor. Aenean lacinia bibendum nulla sed consectetur.
                Praesent commodo cursus magna, vel scelerisque nisl consectetur
                et. Donec sed odio dui. Donec ullamcorper nulla non metus auctor
                fringilla.
              </p>
            </div>
            <div className="modal-footer custom-footer">
              <div className="row w-100">
                <div className="col-6 d-flex justify-content-center">
                  <button
                    type="button"
                    className="custom-button"
                    data-dismiss="modal"
                    data-toggle="modal"
                data-target="#exampleModalpackage"
                  >
                    Decline
                  </button>
                </div>
                <div className="col-6 d-flex justify-content-center">
                  <button
                    type="button"
                    className="custom-button"
                    data-dismiss="modal"
                    data-toggle="modal"
                data-target="#exampleModalpackage"
                  >
                    Accept
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="exampleModalpackage"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="exampleModalLongTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">
                Package (Terms & Conditions)
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            {packagesbyid && (
              <div
                className="modal-body"
                style={{ overflowY: "auto" }}
                dangerouslySetInnerHTML={{ __html: packagesbyid.note }}
              />
            )}

            <div className="modal-footer custom-footer">
              <div className="row w-100">
                <div className="col-6 d-flex justify-content-center">
                  <button
                    type="button"
                    className="custom-button"
                    data-dismiss="modal"
                    onClick={handleNext}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Package;
